import * as MaterialIcons from '@material-ui/icons';

// Tailwind não tem safelist: classe montada por interpolação não entra no CSS gerado.
const colorClasses = {
    slate: 'bg-slate-50 text-slate-700',
    gray: 'bg-gray-50 text-gray-700',
    zinc: 'bg-zinc-50 text-zinc-700',
    neutral: 'bg-neutral-50 text-neutral-700',
    stone: 'bg-stone-50 text-stone-700',
    red: 'bg-red-50 text-red-700',
    orange: 'bg-orange-50 text-orange-700',
    amber: 'bg-amber-50 text-amber-700',
    yellow: 'bg-yellow-50 text-yellow-700',
    lime: 'bg-lime-50 text-lime-700',
    green: 'bg-green-50 text-green-700',
    emerald: 'bg-emerald-50 text-emerald-700',
    teal: 'bg-teal-50 text-teal-700',
    cyan: 'bg-cyan-50 text-cyan-700',
    sky: 'bg-sky-50 text-sky-700',
    blue: 'bg-blue-50 text-blue-700',
    indigo: 'bg-indigo-50 text-indigo-700',
    violet: 'bg-violet-50 text-violet-700',
    purple: 'bg-purple-50 text-purple-700',
    fuchsia: 'bg-fuchsia-50 text-fuchsia-700',
    pink: 'bg-pink-50 text-pink-700',
    rose: 'bg-rose-50 text-rose-700',
};

const defaultColorClass = colorClasses.blue;

export default function NotificationTypeIcon({ layoutInfo }) {

    const IconComponent = MaterialIcons[layoutInfo?.materialIcon] || MaterialIcons.LibraryBooks;
    const colorClass = colorClasses[layoutInfo?.tailwindColor] || defaultColorClass;

    return (
        <div
            data-testid="notification-type-icon"
            className={`flex-none w-9 h-9 rounded-lg flex items-center justify-center ${colorClass}`}
        >
            <IconComponent className="!text-[18px]" />
        </div>
    );
}
